export enum NavigationRoute {
  //Home
  Home = "/",
  // Location
  Location = "/location",
  LocationDetail = "/locationdetail",

  // Menu & Webshop
  MenuGroup = "/menugroup",
  MenuService = "/menuservice",
  MenuLocation = "/menulocation",
  Menu = "/menu",
  MenuDetail = "/menudetail",
  Recipelink = "/recipeLink",
  Webshop = "/webshop",

  // Order requirements
  OrderAddressQuery = "/orderAddressQuery",
  OrderTimeSelector = "/orderTimeSelector",
  RemoteOrderModeSelector = "/remoteOrderModeSelector",

  // Basket & Checkout
  Checkout = "/checkout",
  OrderResult = "/orderresult",

  // Remote Group Orders
  RemoteOrderGroupEntry = "/remoteOrderGroupEntry",
  RemoteOrderGroupDefineTime = "/remoteOrderGroupDefineTime",
  RemoteOrderGroupDefineName = "/remoteOrderGroupDefineName",
  RemoteOrderGroupServiceSelector = "/remoteOrderGroupServiceSelector",
  RemoteOrderGroupCreateConfirm = "/remoteOrderGroupCreateConfirm",
  RemoteOrderGroupShare = "/remoteOrderGroupShare",
  RemoteOrderGroupOverview = "/remoteOrderGroupOverview",
  RemoteOrderGroupSummary = "/remoteOrderGroupSummary",
  RemoteOrderGroupPayment = "/remoteOrderGroupPayment",
  RemoteOrderGroupPayResult = "/remoteOrderGroupPayResult",
  RemoteOrderGroupMemberDetail = "/remoteOrderGroupMemberDetail",

  // IH Group Orders
  IHGroupOrderServiceSelector = "/groupOrderServiceSelector",
  IHGroupOrderGuide = "/groupOrderGuide",
  IHGroupOrderCreateGroup = "/groupOrderCreateGroup",
  IHGroupOrderOverview = "/groupOrderOverview",
  IHGroupOrderShare = "/groupOrderShare",
  IHGroupOrderInvite = "/groupOrderInvite",
  IHGroupMemberOrderDetail = "/groupMemberOrderDetail",

  // In-House Orders
  InHouseServiceSelector = "/inHauseServiceSelector",//!Note the typo "InHause" is intentional to match the original code
  InHouseUserNameRequest = "/inHouseUserNameRequest",
  InHouseTableOverview = "/inHouseTableOverview",
  InHouseOrderResult = "/inHouseOrderresult",
  InHousePayment = "/inHausePayment",//!Note the typo "InHause" is intentional to match the original code
  InHousePaymentOrder = "/inHousePaymentOrder",
  InHouseOrderModeSelector = "/orderModeSelector",
  InHouserOrderConfirm = "/inHauseOrderConfirm",//!Note the typo "InHause" is intentional to match the original code

  // QR & Scanner
  QRCodeScanner = "/qrcodescanner",
  QRCodeInput = "/qrcodeinput",
  CouponCodeScanner = "/couponCodeScanner",

  // Vouchers
  VoucherCredit = "/vouchercredit",
  Webvoucher = "/webvoucher",
  WebvoucherDetail = "/webvoucherdetail",
  WebvoucherCustomDetail = "/webVoucherCustomDetail",
  WebvoucherSelector = "/webVoucherSelector",

  // User Profile
  UserProfile = "/userprofile",
  UserProfileDetail = "/userprofiledetail",
  UserOrderDetail = "/userOrderDetail",
  UserLikes = "/userlike",
  UserAddress = "/useraddress",
  BillingInfo = "/billinginfo",

  // Auth
  Login = "/login",
  Registration = "/registration",
  RegistrationData = "/registrationdata",
  LoginActivation = "/loginactivation",
  ForgetPassword = "/forgetpassword",
  ChangePassword = "/changepassword",

  // Bonus 
  BonusAction = "/bonusaction",
  BonusActionDetail = "/bonusactiondetail",

  // Coupon  (only App)
  Coupon = "/coupon",
  CouponDetail = "/coupondetail",
  CouponRedeem = "/couponRedeem",

  // News (only App)
  News = "/news",
  NewsDetail = "/newsdetail",

  // Events (only App)
  Event = "/event",
  EventDetail = "/eventdetail",

  // Other
  Basemap = "/basemap",
  CustomAction = "/customAction",
  CustomerData = "/customerdata",
  Feedback = "/feedback",
  Onboarding = "/onboarding",
  Reservation = "/reservation",
  TermCondition = "/termcondition",
  ServiceCall = "/servicecall",
  Load = "/load",
  FixBasketError = "/fixedBasketError",
  RevokeOrder = "/revokeOrder",
  RevokeOrderResult = "/revokeOrderResult",

  // None
  None = "",
}